export default __webpack_public_path__ + "static/media/684.142e8801.png";